import { render, staticRenderFns } from "./CookieConsent.vue?vue&type=template&id=5e1807ac&scoped=true&"
import script from "./CookieConsent.vue?vue&type=script&setup=true&lang=js&"
export * from "./CookieConsent.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CookieConsent.vue?vue&type=style&index=0&id=5e1807ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1807ac",
  null
  
)

export default component.exports